/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Notifications_initialViewer = {
    readonly conversations?: {
        readonly metadata: {
            readonly lastUnreadMessageDate: string | null;
            readonly totalUnreadConversationCount: number | null;
        } | null;
    } | null;
    readonly " $refType": "Notifications_initialViewer";
};
export type Notifications_initialViewer$data = Notifications_initialViewer;
export type Notifications_initialViewer$key = {
    readonly " $data"?: Notifications_initialViewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Notifications_initialViewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Notifications_initialViewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "conversations",
          "storageKey": "conversations(filter:\"showUnreadOnly\")",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": "showUnreadOnly"
            }
          ],
          "concreteType": "ConversationConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "metadata",
              "storageKey": null,
              "args": null,
              "concreteType": "ConversationMetadata",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "lastUnreadMessageDate",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "totalUnreadConversationCount",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'ead0a94a895db405d6be11156726621e';
export default node;
